import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Spinner,
  Button
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import axiosInstance from "../../../helpers/axiosInstance";
import TableContainer from "../../../components/Common/TableContainer";

const EcommerceCustomers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [allUsers, setAllUsers] = useState([]);

  const breadcrumbItems = [
    { title: "Ecommerce", link: "#" },
    { title: "Customers", link: "#" },
  ];

  useEffect(() => {
    fetchUsers();
  }, [currentPage]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/api/v1/admin/users", {
        params: {
          page: currentPage,
          limit: pageSize,
        },
      });

      setAllUsers(response.data.users);
      const filteredUsers = filterUsers(response.data.users, searchQuery);
      setUsers(filteredUsers);
      setTotalUsers(response.data.pagination.totalUsers);
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const filterUsers = (users, query) => {
    if (!query) return users;
    
    return users.filter(user => 
      user.name?.toLowerCase().includes(query.toLowerCase()) ||
      user.email?.toLowerCase().includes(query.toLowerCase()) ||
      user.phone?.toLowerCase().includes(query.toLowerCase())
    );
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    const filteredUsers = filterUsers(allUsers, query);
    setUsers(filteredUsers);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleExportAll = () => {
    const csvData = users.map(user => ({
      Name: user.name || '',
      Email: user.email || '',
      Phone: user.phone || '',
      JoinedDate: formatDate(user.createdAt)
    }));

    const headers = Object.keys(csvData[0]);
    const csvContent = [
      headers.join(','),
      ...csvData.map(row => headers.map(header => `"${row[header]}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'customers.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Customers" breadcrumbItems={breadcrumbItems} />

        <Row>
          <Col xs={12}>
          
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="card-title mb-0">Customers List</h4>
                  <div className="d-flex gap-2">
                  <Button color="success" className="me-2" onClick={handleExportAll}>
                      <i className="ri-file-download-line me-1"></i>
                      Export All
                    </Button>
                    <div className="search-box">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search customers..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                    
                  </div>
                </div>

                {loading ? (
                  <div className="text-center my-5">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Contact Info</th>
                            {/* <th>Wallet Balance</th> */}
                            <th>Joined</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.map((user, index) => (
                            <tr key={user._id}>
                              <td>{(currentPage - 1) * pageSize + index + 1}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="avatar-xs me-2">
                                    <div className="avatar-title rounded-circle bg-primary-subtle text-primary">
                                      {user.name?.charAt(0).toUpperCase() || "U"}
                                    </div>
                                  </div>
                                  <span>{user.name}</span>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p className="mb-1">{user.email}</p>
                                  <p className="mb-0 text-muted">{user.phone}</p>
                                </div>
                              </td>
                              {/* <td>
                                <span className="text-primary fw-medium">
                                  {formatCurrency(user.walletBalance || 0)}
                                </span>
                              </td> */}
                              <td>{formatDate(user.createdAt)}</td>
                              <td>
                                <Link
                                  to={`/user-details/${user._id}`}
                                  className="text-success"
                                >
                                  <i className="mdi mdi-eye-circle font-size-18" />
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-4">
                      {/* <div className="text-muted">
                        Showing {(currentPage - 1) * pageSize + 1} to{" "}
                        {Math.min(currentPage * pageSize, totalUsers)} of{" "}
                        {totalUsers} entries
                      </div> */}
{/* 
                      <Pagination>
                        <PaginationItem disabled={currentPage === 1}>
                          <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
                        </PaginationItem>
                        
                        {renderPagination()}
                        
                        <PaginationItem disabled={currentPage >= totalPages}>
                          <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
                        </PaginationItem>
                      </Pagination> */}
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EcommerceCustomers;
